import axios from 'axios'

$(() => {
  const $container = $('.js-order-messages');
  if (!$container.length) return;

  let isLoading = false;

  const getLastId = () => {
    const firstMessage = $container.find('.mcv-order-message').first();
    if (!firstMessage.length) return null;

    return firstMessage.attr('id')?.replace('mcv-order-message-', '');
  };

  const loadMore = (lastOrderMessageId) => {
    if (isLoading) return Promise.resolve();
    isLoading = true;

    const orderId = $container.data('order-id');

    return axios.get(`/mypage/orders/${orderId}/order_messages/load_more`, {
      params: {
        last_order_message_id: lastOrderMessageId
      },
      responseType: 'text'
    })
    .then(resp => {
      if (!resp.data || !resp.data.trim()) {
        $('.js-order-message-load-more').remove();
        return;
      }

      prependHtml(resp.data);
    })
    .catch(() => {
      alert('読み込みに失敗しました');
    })
    .finally(() => {
      isLoading = false;
    });
  };

  const prependHtml = (html) => {
    const prevHeight = $container[0].scrollHeight;

    $container.prepend(html);

    // スクロール位置維持
    $container.scrollTop(
      $container[0].scrollHeight - prevHeight + $container.scrollTop()
    );
  };

  // クリック（動的対応）
  $(document).on('click', '.js-order-message-load-more', function () {
    const $btn = $(this);
    const $loading = $('.js-order-message-loading');

    const lastId = getLastId();

    $btn.hide();
    $loading.show();

    loadMore(lastId).then(() => {
      $loading.remove();
    });
  });

  // 初回
  loadMore(null);
});